import { PROJECT_TASK_TYPE } from '@/entities/project';

import {
  DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  DST_SRT_UPLOADING_TASKS_SEC,
  FINAL_PERCENT_FOR_DST_SRT_UPLOADING_STATUS,
  INITIAL_PERCENT_FOR_DST_SRT_UPLOADING_STATUS,
} from './dstSrtUploading';
import {
  FINAL_PERCENT_FOR_SRC_AND_DST_SRT_UPLOADING_STATUS,
  INITIAL_PERCENT_FOR_SRC_AND_DST_SRT_UPLOADING_STATUS,
  SRC_AND_DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  SRC_AND_DST_SRT_UPLOADING_TASKS_SEC,
} from './srcAndDstUploading';
import {
  FINAL_PERCENT_FOR_SRC_SRT_UPLOADING_STATUS,
  INITIAL_PERCENT_FOR_SRC_SRT_UPLOADING_STATUS,
  SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  SRC_SRT_UPLOADING_TASKS_SEC,
} from './srcSrtUploading';
import {
  FINAL_PERCENT_FOR_GENERATING_VIDEO_STATUS,
  INITIAL_PERCENT_FOR_GENERATING_VIDEO_STATUS,
  VIDEO_GENERATING_SEC_FOR_60_SEC_VIDEO,
  VIDEO_GENERATING_TASKS_SEC,
} from './videoGenerating';
import {
  FINAL_PERCENT_FOR_UPLOADING_VIDEO_STATUS,
  INITIAL_PERCENT_FOR_UPLOADING_VIDEO_STATUS,
  VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  VIDEO_UPLOADING_TASKS_SEC,
} from './videoUploading';
import {
  FINAL_PERCENT_FOR_UPLOADING_AND_GENERATING_VIDEO_STATUS,
  INITIAL_PERCENT_FOR_UPLOADING_AND_GENERATING_VIDEO_STATUS,
  VIDEO_UPLOADING_AND_GENERATING_TASKS_SEC,
  VIDEO_UPLOADING_WITH_GENERATING_SEC_FOR_60_SEC_VIDEO,
} from './videoUploadingWithGenerating';
import {
  FINAL_PERCENT_FOR_VIDEO_UPLOADING_WITH_DST_SRT_STATUS,
  INITIAL_PERCENT_FOR_VIDEO_UPLOADING_WITH_DST_SRT_STATUS,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
  VIDEO_UPLOADING_WITH_DST_SRT_TASKS_SEC,
} from './videoWithDstSrtUploading';
import {
  FINAL_PERCENT_FOR_VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_STATUS,
  INITIAL_PERCENT_FOR_VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_STATUS,
  VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
  VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_TASKS_SEC,
} from './videoWithDstSrtUploadingAndGenerating';
import {
  FINAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_STATUS,
  INITIAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_STATUS,
  VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
  VIDEO_WITH_SRC_SRT_UPLOADING_TASKS_SEC,
} from './videoWithSrcSrtUploading';
import {
  FINAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_AND_GENERATING_STATUS,
  INITIAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_AND_GENERATING_STATUS,
  VIDEO_UPLOADING_AND_GENERATING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
  VIDEO_WITH_SRC_SRT_UPLOADING_AND_GENERATING_TASKS_SEC,
} from './videoWithSrcSrtUploadingAndGenerating';

export const TASK_CONSTANTS = {
  [PROJECT_TASK_TYPE.DstSrtUploading]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_DST_SRT_UPLOADING_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_DST_SRT_UPLOADING_STATUS,
    taskDurationSec: DST_SRT_UPLOADING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.SrcAndDstSrtUploading]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_SRC_AND_DST_SRT_UPLOADING_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_SRC_AND_DST_SRT_UPLOADING_STATUS,
    taskDurationSec: SRC_AND_DST_SRT_UPLOADING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: SRC_AND_DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.SrcSrtUploading]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_SRC_SRT_UPLOADING_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_SRC_SRT_UPLOADING_STATUS,
    taskDurationSec: SRC_SRT_UPLOADING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: SRC_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoGenerating]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_GENERATING_VIDEO_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_GENERATING_VIDEO_STATUS,
    taskDurationSec: VIDEO_GENERATING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_GENERATING_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoUploading]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_UPLOADING_VIDEO_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_UPLOADING_VIDEO_STATUS,
    taskDurationSec: VIDEO_UPLOADING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_UPLOADING_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoUploadingWithGenerating]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_UPLOADING_AND_GENERATING_VIDEO_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_UPLOADING_AND_GENERATING_VIDEO_STATUS,
    taskDurationSec: VIDEO_UPLOADING_AND_GENERATING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_UPLOADING_WITH_GENERATING_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoWithDstSrtUploading]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_VIDEO_UPLOADING_WITH_DST_SRT_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_VIDEO_UPLOADING_WITH_DST_SRT_STATUS,
    taskDurationSec: VIDEO_UPLOADING_WITH_DST_SRT_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoWithDstSrtUploadingWithGenerating]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_STATUS,
    taskDurationSec: VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_UPLOADING_AND_GENERATING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoWithSrcSrtUploading]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_STATUS,
    taskDurationSec: VIDEO_WITH_SRC_SRT_UPLOADING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_UPLOADING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
  },
  [PROJECT_TASK_TYPE.VideoWithSrcSrtUploadingWithGenerating]: {
    finalPercentForStatus: FINAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_AND_GENERATING_STATUS,
    initialPercentForStatus: INITIAL_PERCENT_FOR_VIDEO_WITH_SRC_SRT_UPLOADING_AND_GENERATING_STATUS,
    taskDurationSec: VIDEO_WITH_SRC_SRT_UPLOADING_AND_GENERATING_TASKS_SEC,
    wholeProcessSecFor60SecVideo: VIDEO_UPLOADING_AND_GENERATING_WITH_SRC_SRT_SEC_FOR_60_SEC_VIDEO,
  },
};
